import { useMutation, useQuery } from 'react-query';
import { generateInventoryReport } from './Report.service';
import { InventoryRequest } from './Report.types';
import notificationError from '@/utils/functions/notificationError';

export function useInventoryReport(obj: InventoryRequest) {
  const query = useQuery(['inventory-report'], () =>
    generateInventoryReport(obj),
  );
  return query;
}

export function useInventoryReportMutation() {
  const mutation = useMutation(generateInventoryReport, {
    onError(err) {
      notificationError(err);
    },
  });

  return mutation;
}
